import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './RedditListView.css'; 
import { logEvent } from '../utils/Logger';
import { getCommentRoots, fetchCommentRoots } from '../utils/apiHelpers';

interface RedditPost {
  id: number;
  title: string;
}

const RedditListView: React.FC = () => {
  const [posts, setPosts] = useState<RedditPost[]>([]);
  const location = useLocation();

  useEffect(() => {
    const fetchPosts = async () => {
      const data = await fetchCommentRoots();

      setPosts(data.map((post: any) => ({
        id: post.id,
        title: post.title,
      })));
    };

    fetchPosts();
  }, []);

  const handleTitleClick = (title: string) => {
    logEvent('title_click', title, location.pathname);
  };

  return (
    <div className="reddit-list-view">
      <h1>Reddit Posts</h1>
      <ul>
        {posts.map((post) => (
          <li key={post.id}>
            <Link 
              to={`/comment/${post.id}`}
              onClick={() => handleTitleClick(post.title)}
            >
              {post.title}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RedditListView;